<div class="inner-content" ridangoAppTrapFocus>
    <div
        class="flex-align-center bottom-0 left-0 right-0 top-0 !flex dark:rounded-2xl dark:border-2 dark:border-solid dark:border-contrast-yellow">
        <div class="flex-column flex h-full w-full rounded-2xl bg-white text-base">
            <div class="flex-align-center relative !flex p-4">
                <p class="align-center flex-1 font-semibold">{{ 'SELECT_NEW_PAYMENT_METHOD' | translate }}</p>
                <button
                    class="right-4 text-grey-zambezy"
                    [attr.aria-label]="'CLOSE' | translate"
                    (click)="close()"
                    mat-icon-button>
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <div class="align-center box-border flex-1 overflow-y-auto px-4">
                {{ 'SAVE_THIS_CARD_QUESTION' | translate }}
            </div>

            <div class="m-4 mt-0">
                <ion-button class="mb-2 w-full" (click)="cancel()" size="large" fill="clear">
                    <ion-label class="text-base font-bold normal-case">
                        {{ 'DONT_SAVE_THIS_CARD_CONFIRM' | translate }}
                    </ion-label>
                </ion-button>

                <div class="flex">
                    <button
                        class="vl-app-light:bg-[var(--btn-primary-color)] vl-app-light:text-black var-app-light:text-black h-14 w-full rounded-lg bg-secondary font-bold text-white shadow-md dark:bg-contrast-yellow dark:text-contrast-black"
                        (click)="savePaymentMethodsConfirm()"
                        type="submit">
                        {{ 'SAVE_THIS_CARD_CONFIRM' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
